<template>
  <div>
    <label v-if="label" class="input-label"> {{ label }} <small v-if="showRequired" class="mt-6 error--text">*</small> </label>
    <v-date-input
      append-inner-icon="mdi-calendar-month"
      class="code-clan-date-input"
      v-bind="$attrs"
      :model-value="modelValue"
      @update:modelValue="valueChanged"
      @blur="blur"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: false,
    },
    modelValue: {
      required: true,
    },
    showRequired: {
      type: Boolean,
      required: false,
    },
    showNumberIncSuggestion: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    valueChanged(value: any) {
      this.$emit("update:modelValue", value);
    },
    blur() {
      this.$emit("blur");
    },
  },
  computed: {
    attrs(): any {
      return delete this.$attrs["label"];
    },
  },
});
</script>
